import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faRedoAlt,
} from "@fortawesome/free-solid-svg-icons";
import OtpInput from "react-otp-input";
import apnaq from "../Images/apnaq.svg";
import CircularProgress from "@material-ui/core/CircularProgress";
// import apple from './apple.png'
import { FirebaseContext } from "../Firebase";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import Axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100vw",
    height: "100vh",
    backgroundSize: "100vw,100vh",
    backgroundPosition: "center",
  },

  input: {
    color: "#5A9BB7",
    fontWeight: "500",
    fontSize: "18px",
    '& :-webkit-autofill': {
      '-webkit-text-fill-color': '#5A9BB7 !important',
      // '-webkit-box-shadow': '0 0 0px 1000px #00000000 inset !important',
      "transition":" background-color 5000s",
      "caret-color":"#5A9BB7 !important"
    },    
    fontFamily: "'Poppins', sansSerif",
  },
  // otpInput: {
  //   color: "#4F8CA7",
  //   fontWeight: "300",
  //   letterSpacing: "50px",
  //   fontSize:"16px",
  //   fontFamily: "'Poppins', sansSerif",
  //   boxShadow: "3px 3px 6px 6px #000037",
  // },
  inputRoot: {
    backgroundColor: "inherit",
    width: "30vw",
    padding: ".7vw",
  },
  // otpRoot: { backgroundColor: "inherit", width: "15vw", padding: ".7vw" },
  largeText: {
    color: "#22485D",
    fontSize: "90px",
    fontWeight: "700",
    lineHeight:"1.2",
    fontFamily: "'Poppins', sansSerif",
  },
  largeTextContainer: {
    width: "630px",
    // height:"124px"
  },
  rightSideContainer: {
    padding: "4vw",
    backgroundColor: "#FFFFFF",
  },
}));

export default function Signup(props) {
  var [loading, setLoading] = useState(false);
  var [resendLoading, setResendLoading] = useState(false);
  var [otpSend, setOtpSend] = useState(false);
  var [seconds, setSeconds] = useState(59);
  var [timerExpired, setTimerExpired] = useState(false);

  var [minute, setMinute] = useState(2);

  var [idToken, setIdToken] = useState(false);
  var [userRegistered, setUserRegistered] = useState("");

  var [handleClickResponse, setHandleClickResponse] = useState("");
  var [otp, setOtp] = useState(" ");
  var [otpMsg, setOtpMsg] = useState("");
  var [mobileNumber, setMobileNumber] = useState("");
  var [termsAndCondition, setTermsAndCondition] = useState(false);

  const history = useHistory();
  const classes = useStyles();
  var [reCaptchaVerifier, setreCaptchaVerifier] = useState(false);

  useEffect(() => {
    localStorage.removeItem("idToken")
    setreCaptchaVerifier(
      new firebase.auth.RecaptchaVerifier("captcha", {
        size: "invisible",
        callback: function (response) {
          // console.log("It works!");
        },
      })
    );
    //   reCaptchaVerifier.render();
  }, []);

  const handleClick = (fire) => {
    setTimerExpired(false);
    setMinute(2);
    setSeconds(59);
    setOtpMsg("");
    setLoading(true);
    var mobile = "+91" + mobileNumber;
    setHandleClickResponse("");
    fire
      .DoCreateUserWithPhoneNumber(mobile, reCaptchaVerifier)
      .then((res) => {
        setOtpSend(true);
        let interval = null;

        interval = setInterval(() => {
          setSeconds((seconds) => seconds - 1);
        }, 1000);
        setInterval(() => {
          clearInterval(interval);
        }, 300000);

        setLoading(false);
        setResendLoading(false);

        setHandleClickResponse(res);
        // var otp = window.prompt("enter otp");
        // var otp = otp
        if (otp.length === 6) {
          // console.log("otp entered");
          res.confirm(otp).then(async (result) => {
            // console.log(result);
            // console.log(result.user.uid);
            await fire.getIdToken(history);

            // localStorage.setItem("uid",result.user.uid)
            // localStorage.setItem("refreshToken",result.user.refreshToken)
          });
        }
      })
      .catch((err) => {
        // console.log(err);
        setLoading(false);
        setResendLoading(false);

      });
  };
  useEffect(() => {
    if (seconds < 0) {
      if (minute === 0 && seconds < 0) {
        setTimerExpired(true);
      }
      setMinute(minute - 1);
      setSeconds(59);
    }
  }, [seconds]);
  const handleOtpConfirm = (fire) => {
    setLoading(true);
    setOtpMsg("");
    // console.log("handleOtpConfirm called");
    if (otp.length === 6) {
      // console.log("otp entered");
      handleClickResponse
        .confirm(otp)
        .then(async (result) => {
          // console.log(result);
          // console.log(result.user.uid);
          await fire.getIdToken(history, gotIdToken);

          // localStorage.setItem("uid",result.user.uid)
          // localStorage.setItem("refreshToken",result.user.refreshToken)
        })
        .catch((err) => {
          setLoading(false);
          setOtpMsg("Incorrect OTP");
        });
    }
  };
  const resendOtp = (fire) => {
    setOtp(" ");
    setResendLoading(true)
    handleClick(fire);
  };
  const gotIdToken = () => {
    setIdToken(true);
  };
  const isUserAlreadyRegistered = () => {
    // console.log("isUserAlreadyRegistered called");
    const idToken = localStorage.getItem("idToken");
    Axios.post(
      "https://asia-east2-apnaq-prod.cloudfunctions.net/getUserDataApi",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          authorization: idToken,
        },
      }
    ).then((res) => {
      // console.log("user ", res.data);
      if (res.data.success && res.data.user) {
        // console.log("userdetails success");
        setUserRegistered(true);
        history.push("/dashboard");
      } else {
        setUserRegistered(false);

        // console.log("userdetails failed");
        // history.replace('/')
      }
    });
  };
  
  return (
    <Grid container>
      <Grid
        container
        lg={6}
        style={{ height: "100vh" }}
        alignItems="flex-start"
      >
        <Grid container style={{ padding: "5vw" }}>
          <img
            src={apnaq}
            alt="apnaQ"
            style={{ width: "250px", height: "100px" }}
          />
        </Grid>

        <FirebaseContext.Consumer>
          {(fire) => (
            <Grid
              item
              container
              style={{
                marginLeft: "5vw",
                position: "relative",
                bottom: "10vh",
              }}
              direction="row"
              // justify="center"
              alignItems="flex-start"
            >
              {" "}
              {userRegistered === "" ? (
                <form noValidate onSubmit={handleClick}>
                  <Grid
                    container
                    style={{
                      boxShadow:
                        "3px 3px 3px 0 rgba(255, 255, 255, 0.10),-3px -3px 3px 0 rgba(0, 0, 0, 0.15)",
                    }}
                    alignItems="center"
                  >
                    <Box
                      style={{
                        paddingLeft: "1vw",
                        color: "#31E8DB",
                      }}
                    >
                      <Typography className={classes.input}>+91 |</Typography>
                    </Box>
                    

                    <TextField
                      type="text"
                      // placeholder="Phone number"
                      rows={10}
                      name="mobileNumber"
                      onChange={(e) => {
                        setMobileNumber(e.target.value);
                      }}
                      // disabled={otpSend}
                      variant="standard"
                      value={mobileNumber}
                      fullWidth
                      classes={{
                        root: classes.inputRoot,
                      }}
                      inputProps={{ maxLength: 10 }}
                      InputProps={{
                        disableUnderline: "true",
                        className: classes.input,
                      }}
                    />
                  </Grid>

                  {!otpSend ? (
                    <>
                      <Grid
                        container
                        lg={12}
                        style={{ paddingTop: "1vw", paddingBottom: "1vw" }}
                      >
                        <FormControlLabel
                          style={{
                            color: "#496293",
                            fontFamily: "'Poppins', sansSerif",
                            fontWeight: "300",
                            fontSize: "12px",
                          }}
                          control={
                            <Checkbox
                              checked={termsAndCondition}
                              onChange={() =>
                                setTermsAndCondition(!termsAndCondition)
                              }
                              name="checkedB"
                              style={{
                                color: termsAndCondition
                                  ? "#3BF6C1"
                                  : "#496293",
                                fontWeight: "300",
                                fontSize: "12px",
                              }}
                            />
                          }
                          label="I Agree With Terms And Conditions"
                        />
                      </Grid>

                      <Grid container lg={12}>
                        <Button
                          type="submit"
                          variant="contained"
                          component="div"
                          disabled={
                            mobileNumber.length !== 10 || !termsAndCondition
                          }
                          style={{
                            backgroundColor: "#172941",
                            padding: "1vw",
                            boxShadow:
                              "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
                          }}
                          id="sign-in-button"
                          onClick={() => handleClick(fire)}
                        >
                          {!loading && (
                            <FontAwesomeIcon
                              icon={faArrowRight}
                              style={{ color: "#22FCA8", fontSize: "30px" }}
                            />
                          )}

                          {loading && (
                            <CircularProgress
                              size={30}
                              style={{ color: "#22FCA8" }}
                            />
                          )}
                        </Button>{" "}
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid container style={{ marginTop: "0.7vw" }}>
                        <Typography
                          style={{
                            fontSize: "16px",
                            fontWeight: "300",
                            color: "#4F8CA7",
                            fontFamily: "'Poppins', sansSerif",
                          }}
                        >
                          Enter Code
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        spacing={3}
                        style={{
                          marginTop: ".7vw",

                          marginBottom: "0.7vw",
                        }}
                      >
                        <Grid
                          container
                          item
                          lg={9}
                          style={
                            {
                              // border: "1px solid #496293",
                              // boxShadow: "3px 3px 6px 6px #000037",
                              // width: "13vw",
                            }
                          }
                        >
                          <OtpInput
                            value={otp}
                            onChange={(e) => {
                              setOtp(e);
                            }}
                            inputStyle={{
                              color: "#4F8CA7",
                              fontWeight: "300",
                              // letterSpacing: "50px",
                              fontSize: "16px",
                              fontFamily: "'Poppins', sansSerif",
                              boxShadow:
                                "3px 3px 3px 0 rgba(255, 255, 255, 0.10),-3px -3px 3px 0 rgba(0, 0, 0, 0.15)",
                              padding: "1vw",
                              marginRight: "1vw",
                              backgroundColor: "#172941",
                              border: "none",
                            }}
                            numInputs={6}
                            isInputNum
                            separator={<span> </span>}
                          />
                        </Grid>
                        <Grid item lg={3} justify="center" alignItems="center">
                          {timerExpired ? (
                            <Button
                              type="submit"
                              variant="contained"
                              color="inherit"
                              component="div"
                              style={{
                                marginLeft: "1vw",
                                backgroundColor: "#172941",

                                // display: "inline",
                                boxShadow:
                                  "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",

                                padding: "1vw",
                              }}
                              id="sign-in-button"
                              onClick={() => resendOtp(fire)}
                            >
                              {!resendLoading && (
                                <FontAwesomeIcon
                                  icon={faRedoAlt}
                                  style={{ color: "#22FCA8", fontSize: "20px" }}
                                />
                              )}

                              {resendLoading && (
                                <CircularProgress
                                  size={20}
                                  style={{ color: "#22FCA8" }}
                                />
                              )}
                            </Button>
                          ) : (
                            <Typography
                              style={{
                                color: "#4F8CA7",
                                fontSize: "20px",
                                marginTop: "1vw",
                                fontFamily: "'Poppins', sansSerif",
                              }}
                            >
                              0{minute} :{" "}
                              {seconds.toString().length === 1 ? (
                                <>0{seconds}</>
                              ) : (
                                seconds
                              )}
                            </Typography>
                          )}
                        </Grid>
                      </Grid>

                      <Grid container style={{ marginBottom: "0.7vw" }}>
                        <Typography
                          style={{
                            fontSize: "14px",
                            fontWeight: "300",
                            color: "#5A9BB7",
                            width: "50%",
                            fontFamily: "'Poppins', sansSerif",
                          }}
                        >
                          We have sent you an access code via SMS for mobile
                          number verification
                        </Typography>
                      </Grid>
                      <Grid container style={{ marginBottom: "0.7vw" }}>
                        <Typography
                          style={{
                            fontSize: "14px",
                            fontWeight: "300",
                            color: "#FF4183",
                            fontFamily: "'Poppins', sansSerif",
                          }}
                        >
                          {otpMsg}
                        </Typography>
                      </Grid>
                      <Grid container lg={12}>
                        {otp.length === 6 && resendLoading===false ? (
                          <Button
                            type="submit"
                            variant="contained"
                            color="inherit"
                            component="div"
                            style={{
                              boxShadow:
                                "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",

                              padding: "1vw",
                              backgroundColor: "#172941",
                            }}
                            id="sign-in-button"
                            onClick={() => handleOtpConfirm(fire)}
                          >
                            {!loading && (
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                style={{ color: "#22FCA8", fontSize: "30px" }}
                              />
                            )}

                            {loading && (
                              <CircularProgress
                                size={30}
                                style={{ color: "#22FCA8" }}
                              />
                            )}
                          </Button>
                        ) : null}
                      </Grid>
                      {idToken
                        ? localStorage.getItem("idToken")
                          ? isUserAlreadyRegistered()
                          : null
                        : null}
                    </>
                  )}

                  <span id="captcha"></span>
                </form>
              ) : (
                <Grid container style={{ width: "30vw" }}>
                  <Grid
                    container
                    style={{
                      boxShadow:
                        "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
                      marginTop: ".7vw",
                      padding: "2vw",
                    }}
                    alignItems="center"
                  >
                    <Typography  style={{
                            fontSize: "14px",
                            fontWeight: "300",
                            color: "#5A9BB7",
                            width: "50%",
                            fontFamily: "'Poppins', sansSerif",
                          }}>
                      Please download our app and register then come back....
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </Grid>
          )}
        </FirebaseContext.Consumer>
      </Grid>
      <Grid
        container
        lg={6}
        className={classes.rightSideContainer}
        alignItems="center"
      >
        <Grid container className={classes.largeTextContainer}>
          <Typography className={classes.largeText}>
            WE QUEUE WHILE YOU SLEEP
          </Typography>
          <Grid container>
            <Typography
              style={{
                fontSize: "20px",
                color: "#3B6D88",
                fontWeight: "200",
                fontFamily: "'Poppins', sansSerif",
              }}
            >
              THE QUEUE OF MY DREAMS
            </Typography>
          </Grid>
          <Grid
            container
            alignItems="center"
            style={{
              paddingLeft: "1vw",
              paddingRight: "1vw",

              border: "5px solid #FEA0B9",
              marginTop: "5vw",
              width: "520px",
            }}
          >
            <Grid container lg={6}>
              <Typography
                style={{
                  color: "#FF4174",
                  fontFamily: "'Poppins', sansSerif",
                  fontSize: "17px",
                  fontWeight: "500",
                }}
              >
                DOWNLOAD FREE{" "}
              </Typography>
            </Grid>

            <Grid
              container
              lg={6}
              direction="row-reverse"
              
            >
              
              <a href="https://play.google.com/store/apps/details?id=com.orbitro.apnaQ&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                <img
                  alt="Get it on Google Play"
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                  style={{ height: "3vw",marginTop:".45vw" }}
                />
              </a>
            </Grid>
            
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
